<!-- 水泵节能设置 -->
<template>
    <div class='container containerBox'>
        <el-form ref="form" :model="form" inline label-width="80px">
            <el-form-item>
                    <el-button type="primary" @click="handleAddPump">增加水泵</el-button>
            </el-form-item>
            
          <lb-table v-loading="loading"
            :column="tableData.column"
            :data="tableData.data"
            :height="maxHeight"
            >
        </lb-table>
        </el-form>

        <el-dialog
            :title="titlename"
            :visible.sync="dialogVisible"
            width="50%"
            :before-close="handleClose">
            <el-form :model="pumpForm"  label-width="120px" ref="pumpForm">
                <el-form-item label="名称"
                prop="pumps_name"
                :rules="[
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ]">
                    <el-input v-model="pumpForm.pumps_name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="集控器"
                prop="collector_serial"
                :rules="[
                    { required: true, message: '请选择集控器', trigger: 'change' }
                ]">
                    <el-select v-model="pumpForm.collector_serial" style="width:100%;" filterable placeholder="请选择" @change="changeCollector" :disabled="istrue">
                        <el-option
                            v-for="item in collectorList"
                            :key="item.oid"
                            :label="item.dev_name +' : ' + item.dev_serial"
                            :value="item.dev_serial">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="PLC"
				
                prop="terminal_serial"
                :rules="[
                    { required: true, message: '请选择PLC', trigger: 'change' }
                ]">
                    <el-select v-model="pumpForm.terminal_serial" style="width:100%;" filterable placeholder="请选择" @change="changePlc" :disabled="istrue">
                        <el-option
                            v-for="item in plcList"
                            :key="item.oid"
                            :label="item.customized_serial + ' : ' + item.device_model"
                            :value="item.terminal_serial">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备参数"
				
                prop="addr"
                :rules="[
                    { required: true, message: '请选择设备参数', trigger: 'change' }
                ]">
                    <el-select v-model="pumpForm.addr" filterable placeholder="请选择变量地址" :disabled="istrue">
                        <el-option
                            v-for="item in varData"
                            :key="item.value"
                            :label="item.var_name+' : '+item.var_Initial_addr"
                            :value="item.var_Initial_addr">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="改造前功率"
                prop="before_power"
                :rules="[
                    { required: true, message: '请输入改造前功率', trigger: 'blur' }
                ]">
                    <el-input v-model.number="pumpForm.before_power" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="改造后功率"
                prop="after_power"
                :rules="[
                    { required: true, message: '请输入改造后功率', trigger: 'blur' }
                ]">
                    <el-input v-model.number="pumpForm.after_power" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSaveVar">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'

import LbTable from '@/components/lb-table/lb-table'
import { getMaxHeigth, $Alert } from '@/utils/utils'

export default {
    name:  'pumpsetting',
    data() {
        return {
            deviceList: [],
            form: {
                price: '',
                percent: '',
            },

            // addr弹框
			titlename:"增加水泵",
			istrue:false,
            dialogVisible: false,
            pumpForm: {
                collector_serial: '',
                terminal_serial: '',
                addr: '',
                pumps_name: '',
                before_power: '',
                after_power: '',
            },

            tableData: {
                column: [
                    {
                        type: 'index',
                        align: 'center'
                    },
                    {
                        prop: 'pumps_name',
                        label: '水泵名称',
                        sortable: true,
                    },
                    {
                        prop: 'addr',
                        label: '变量地址',
                        sortable: true,
                    },
                    {
                        prop: 'before_power',
                        label: '改造前功率(kWh)'
                    },
                    {
                        prop: 'after_power',
                        label: ' 改造后功率(kWh)',
                    },
                    {
                        label: '操作',
                        width: '180px',
                        render: (h, scope) => {
                        return (
                            <div>
                            <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                onClick={ () => { this.handleEditPump(scope.row) } }></el-button>
                            <el-button
                                size="mini"
                                type="danger"
                                icon="el-icon-delete"
                                onClick={ () => { this.handleDetelePump(scope.row) } }></el-button>
                            </div>
                        )
                        }
                    }
                ],
                data: []
            },
            loading: false,
            maxHeight: 500,
        };
    },
    computed: {
        ...mapGetters(["machine"]),
        collectorList() {
            return this.machine.collect
        },
        plcList() {
            return this.machine.devices
        },
        varData() {
            return this.machine.var_config
        }
    },
    components: { LbTable },

    created() {
        this.getList();
        this.getData()
    },
    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },
    methods: {
        async getData() {
            let params = {
                page_num:1,
                page_sum: 100,
            }
            let res = await Service.getPumpsEnergy(params);
            if(res.list) {
                this.tableData.data = res.list
            }
        },
        // 获取集控器列表
        async getList() {

            let data = await Service.getCollector();
            if(data){
                data = data === 'success' ? [] : data;
				this.$store.dispatch('setCollect', data);
            }
        },
        // 获取表计
        async getDeviceList(collectId) {
            let params = Object.assign({}, { page_num: 1, page_sum: 1000, }, {OID: collectId});
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                if(list.length>0) {
                    this.pumpForm.terminal_serial = '';
                    this.$store.dispatch('setDevices', list);
                }
            }
        },
        // 获取变量列表
        async getPlcConfig(terminal_id) {
            
            if(terminal_id === '') return
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 1000,
            }
            
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.$store.dispatch('setVarConfig', list);
            }
        },
        changeCollector(val) {
            let oid = this.collectorList.filter(v=>{return v.dev_serial === val})[0].oid
            this.getDeviceList(oid)
        },
        changePlc(val) {
            let oid = this.plcList.filter(v=>{return v.terminal_serial === val})[0].oid
            this.getPlcConfig(oid);
        },
        handleAddPump() {
            this.dialogVisible = true;
			this.istrue = false;
			this.titlename="增加水泵";
            this.pumpForm = {
                collector_serial: '',
                terminal_serial: '',
                addr: '',
                pumps_name: '',
                before_power: '',
                after_power: '',
            }
            this.$refs['pumpForm'].resetFields();
        },
        handleEditPump(row) {
            this.pumpForm = Object.assign({}, row)
            this.dialogVisible = true;
			this.istrue = true;
			this.titlename="修改水泵";
        },
        handleDetelePump(row) {
            $Alert(`是否确认删除 ${row.pumps_name} `).then( async (bool)=>{
                if(bool){
                    let res = await Service.delPumpsEnergy({oid: row.oid});
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getData()
                    }
                }
           });
        },
        // 关闭弹框前
        handleClose(done) {
            this.$refs['pumpForm'].resetFields();
            done()
        },
        // 确认地址
        handleSaveVar() {
            this.$refs['pumpForm'].validate(async (valid) => {
                if (valid) {
                    let res
                    if(this.pumpForm.oid) {
                        res = await Service.editPumpsEnergy(this.pumpForm)
                    }else{
                        res = await Service.addPumpsEnergy(this.pumpForm)
                    }
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!',
                        });
                        this.getData()
                        this.dialogVisible = false;
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
    }
}

</script>
<style lang='less' scoped>
    .list-box{
        margin: 0 20px 20px;
    }
    .header-item{
        background-color: #fafafa;
    }
    .item{
        height: 60px;
        text-align: center;
        line-height: 40px;
        box-sizing: border-box;
        border-bottom: 1px solid #eee;
        padding: 10px 0;
    }
</style>